import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { BreadcrumbContainer, CustomBreadcrumbWrapper } from "./Breadcrumb.styled";
import { DrivesTabsEnum } from "../../enums/drivesTabs";
import { useStore } from "../../../../../hooks/";

const Breadcrumb = observer(({selectedTab, onTabChange }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { breadcrumbStore } = useStore();

  const handleNavigate = (href) => {
    if (href && href !== pathname) {
      navigate(href);
    }
  };

  const getTabLabel = (tabIndex) => {
    switch (tabIndex) {
      case DrivesTabsEnum.DRIVES:
        return "Drives";
      case DrivesTabsEnum.MY_WORKSPACE:
        return "My Workspace";
      case DrivesTabsEnum.SHARED_WITH_ME:
        return "Shared with me";
      default:
        return "Drive";
    }
  };

  
  useEffect(() => {
    breadcrumbStore.setBreadcrumb({
      base: { label: 'AIMS Drive', href: '/v2/drives' },
      context: { label: getTabLabel(selectedTab) }
    });
    breadcrumbStore.setCurrentPath(pathname);
  }, [selectedTab, pathname]);

  return (
    <BreadcrumbContainer>
      <CustomBreadcrumbWrapper>
        <DynamicBreadcrumbs 
          items={breadcrumbStore.breadcrumbItems} 
          currentPath={breadcrumbStore.currentPath}
          onNavigate={handleNavigate}
        />
      </CustomBreadcrumbWrapper>
    </BreadcrumbContainer>
  );
});

export default Breadcrumb;
